import { render, staticRenderFns } from "./InterpreterInfoSection.vue?vue&type=template&id=25d97731&scoped=true&"
import script from "./InterpreterInfoSection.vue?vue&type=script&lang=js&"
export * from "./InterpreterInfoSection.vue?vue&type=script&lang=js&"
import style0 from "./InterpreterInfoSection.vue?vue&type=style&index=0&id=25d97731&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d97731",
  null
  
)

export default component.exports